import { Button } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Input } from '@devotel/design-system';

const CenteredInput = styled(Input)`
  .ant-input {
    text-align: center;
  }
`;

export type StepPerNumberInputProps = {
  value: number;
  step?: number;
  min?: number;
  max?: number;
  onChange: (value: number) => void;
  className?: string;
};

export function StepPerNumberInput({
  value = 1,
  step = 1,
  min = 0,
  max,
  onChange,
  className = '',
}: Readonly<StepPerNumberInputProps>) {
  const round = (num) => {
    return Math.round(num * 1e10) / 1e10;
  };

  const handleMinus = () => {
    const newValue = round(value - step);
    if (newValue >= min) {
      onChange(newValue);
    }
  };

  const handlePlus = () => {
    const newValue = round(value + step);
    if (max !== undefined && newValue > max) {
      onChange(max);
    } else {
      onChange(newValue);
    }
  };

  return (
    <CenteredInput
      className={`!bg-wl-background text-wl-on-background border-none ${className}`}
      prefix={
        <Button
          className='!bg-wl-background border-none'
          icon={<MinusOutlined className='text-wl-on-background' />}
          onClick={handleMinus}
        />
      }
      suffix={
        <Button
          className='!bg-wl-background border-none'
          icon={<PlusOutlined className='text-wl-on-background' />}
          onClick={handlePlus}
        />
      }
      min={min}
      max={max}
      value={value + 'GB'}
      step={step}
      onChange={(e) => {
        if (!e.target.value.toLowerCase().includes('gb')) {
          e.target.value = e.target.value.replace(/(\d)(?!.*\d)/, '');
        }
        const numericValue = Number(e.target.value.replace(/[^\d.]/g, ''));
        if (numericValue >= min && (max === undefined || numericValue <= max)) {
          onChange(numericValue);
        }
      }}
    />
  );
}
